/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

export const ModalContent = styled.div`
  padding: 0 ${spacing.xLarge} ${spacing.xLarge};
  font-size: 14px;
  line-height: 17px;
`;
